module.exports = (state, action) => {
  const { loaded } = action.payload
  state.mainContentLoaded = loaded
}
